import { useState, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import InfoBoxes from '../components/item/InfoBoxes'
import ItemGraphic from '../components/item/ItemGraphic'
import './ItemView.css'
import '../shared/styles/header.css'

function ItemView(props) {
    const id = useParams()
    const history = useHistory()
    const [singleItem, setSingleItem] = useState([])
    const [error, setError] = useState(false)

    useEffect(() => {
        const getSingleItemFromParam = () => {
            setError(false)
            let findItem = props.data.find(item => item.slug === id.id)
            if (findItem === undefined) {
                findItem = []
                setError(true)
            }
            setSingleItem(findItem)
        }
        getSingleItemFromParam()
    }, [id, props.data])

    return (
        <div className="itemView">
            <div className="title">{!error ? singleItem.name : "Fel!"}</div>
            <div className="itemContent">

                {!error ? 
                <>
                    <ItemGraphic
                        singleItem={singleItem}
                    />
                    <img 
                        src={singleItem.img ? singleItem.img : "img/no-photo.jpg" } 
                        alt={singleItem.name}
                        className="itemPicture"
                        width="100%" 
                    />
                    <p>{singleItem.desc ? singleItem.desc : "Information saknas"}</p>
                    <br />
                    <InfoBoxes 
                        singleItem={singleItem}
                    />
                    <div className="contentFooter">
                        <div>
                            {singleItem.copyright}
                        </div>
                            <button onClick={() => history.goBack()}>Tillbaka</button>
                    </div>
                </>
                : <p>Frukten eller grönsaken finns inte. Vänligen försök igen.</p>
                }

            </div>
        </div>
    )
}

export default ItemView